import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as common from '../../../../../common'
import * as models from '../../models'

import * as gql from './gql'

@ngCore.Injectable()
export class ApiService {
  /** TODO: */
  public render({
    alias,
    appId,
    appPageId,
    pageId,
    tenantId,
    zoneId,
    scenarioId,
    variables,
  }: models.segment.Request): rxjs.Observable<
    ents.core.mosaic.Page.Segment.Rendering | undefined
  > {
    return gql.queries.mosaicPageSegmentInfo.executor({
      alias,
      appId,
      appPageId,
      pageId,
      // TODO:  SHOULD be optional on graphql schema.
      scenarioId: scenarioId ?? 'TODO',
      tenantId,
      variableOverrides:
        common.gql.dms.data.inputs.variableValue.TRANSFORMER.getGqlFrom(
          variables,
        ),
      zoneId,
    })
  }
}
